var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.997 13.1758C3.684 13.1758 0 13.8558 0 16.5758C0 19.2968 3.661 20.0008 7.997 20.0008C12.31 20.0008 15.994 19.3218 15.994 16.6008C15.994 13.8798 12.334 13.1758 7.997 13.1758Z",
    fill: "#CBD5E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.99708 10.584C10.9351 10.584 13.2891 8.229 13.2891 5.292C13.2891 2.355 10.9351 0 7.99708 0C5.06008 0 2.70508 2.355 2.70508 5.292C2.70508 8.229 5.06008 10.584 7.99708 10.584Z",
    fill: "#CBD5E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserIcon);
export default __webpack_public_path__ + "static/media/defaultUserIcon.880d65e7219dfd505992c01eb5874650.svg";
export { ForwardRef as ReactComponent };